import {indexedDBName, indexedDBVersion} from '../sw-vars'

export default {
	methods: {
		/*************
		 * Setup connection to IndexedDB
		 *************/
		async getIndexedDBConnection() {
			return new Promise((resolve, reject) => {
				let request = window.indexedDB.open(indexedDBName, indexedDBVersion)

				request.onsuccess = event => {
					resolve(event.target.result)
				}
			})
		},
		
		/*************
		 * Fetch data
		 *************/
		async getRequestsInIndexedDB(table) {
			const db = await this.getIndexedDBConnection()
			return new Promise((resolve, reject) => {
				const tx = db.transaction(table, 'readonly')
				tx.oncomplete = event => {
					resolve(requests)
				}

				const requests = []

				const store = tx.objectStore(table)
				store.openCursor().onsuccess = event => {
					let cursor = event.target.result
					if(cursor) {
						requests.push(cursor.value)
						cursor.continue()
					}
				}
			})
		},
		async getSitePlansInIndexedDB() {
			const db = await this.getIndexedDBConnection()
			return new Promise((resolve, reject) => {
				const tx = db.transaction('data', 'readonly')
				tx.oncomplete = event => {
					resolve({ plansJPG })
				}
				const store = tx.objectStore('data')
				let plansJPG = []

				const request = store.getAll();
				request.onsuccess = event => {
					const plans = event.target.result.filter(record => record.key.includes('pwa/intervention/') && record.key.includes('/plan/'))
					plans.map(plan => {
						const jpg = { id: plan.value.id, url: plan.value.url }
						if(!plansJPG.some(p => p.id === jpg.id)) {
							plansJPG.push(jpg)
						}
					})
				}
			})
		},
		async fetchDataFromIndexedDB(key) {
			const db = await this.getIndexedDBConnection()
			return new Promise((resolve, reject) => {
				const tx = db.transaction('data', 'readonly')
				tx.oncomplete = event => {
					resolve(data)
				}

				const store = tx.objectStore('data')
				const request = store.get(key)
				
				let data
				request.onsuccess = event => {
					data = event.target.result
				}
			})
		},
		
		/*************
		 * Requests & Failed Request
		 *************/
		async storeRequest(key, json) {
			const db = await this.getIndexedDBConnection()
			new Promise(() => {
				const tx = db.transaction('requests', 'readwrite')
				const store = tx.objectStore('requests')
				store.put({ key: key, value: json, timestamp: Date.now() })
			})
		},
		async storeFailedRequest(key, userId, payload, timestamp, error) {
			const db = await this.getIndexedDBConnection()
			new Promise(() => {
				const tx = db.transaction('failed_requests', 'readwrite')
				const store = tx.objectStore('failed_requests')
				store.put({ key: key, userId: userId, payload: payload, timestamp: timestamp, error: error })
			})
		},
		
		/*************
		 * Clear and Delete
		 *************/
		async clearIndexedDBTable(table) {
			const db = await this.getIndexedDBConnection()
			new Promise(() =>  {
				const tx = db.transaction(table, 'readwrite')
				const store = tx.objectStore(table)
				store.clear()
			})
		},
		async deleteRequestInIndexedDB(key) {
			const db = await this.getIndexedDBConnection()
			new Promise(() => {
				const tx = db.transaction('requests', 'readwrite')
				const store = tx.objectStore('requests')
				store.delete(key)
			})
		},
		
		/*************
		 * Debuging
		 *************/
		async getTableNames() {
            return await this.getIndexedDBConnection()
		},
        async getCacheKey() {
            return new Promise((resolve, reject) => {
                caches.keys().then((cacheNames) => {
                    resolve(cacheNames)
                })
            })
		}
	}
}
